import type { IconSvgObject } from './types';

const DigestionIcon: IconSvgObject = [
  ["path", { d: "M9.48456 2C9.72844 3.49019 10.4411 4.57432 12.475 3.87202C16.6773 2.42099 19.9986 6.8491 19.9986 10.8C19.9986 14.7765 17.353 18 14.0895 18H13.0247C10.492 18 8.27592 19.6321 7.45312 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.00579 2V2.77557C6.00579 6.57844 11.4279 9.38737 9.63735 13.1999C8.92581 14.715 4.89482 17.2931 3.99999 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 7C14.9576 7.29708 15.7109 8.04937 16 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DigestionIcon;
